var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-delivery-template" },
    [
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _vm._l(_vm.list, function (item) {
            return [
              _vm.list.length
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          key: item.id,
                          staticClass: "mt20",
                          attrs: { data: item.detailList, size: "small" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { "min-width": "400" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      item.deliveryType === "express"
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "font-color" },
                                              [_vm._v("【快递配送】")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.expressName +
                                                    "：" +
                                                    item.trackingNumber
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "span",
                                              { staticClass: "ml30" },
                                              [_vm._v(_vm._s(item.createTime))]
                                            ),
                                          ]
                                        : item.deliveryType === "merchant"
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "font-color" },
                                              [_vm._v("【商家送货】")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.deliveryCarrier +
                                                    "：" +
                                                    item.carrierPhone
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "span",
                                              { staticClass: "ml30" },
                                              [_vm._v(_vm._s(item.createTime))]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "span",
                                              { staticClass: "font-color" },
                                              [
                                                _vm._v(
                                                  "【" +
                                                    _vm._s(
                                                      _vm.info.secondType ===
                                                        _vm.OrderSecondTypeEnum
                                                          .Fictitious
                                                        ? "虚拟发货"
                                                        : "无需配送"
                                                    ) +
                                                    "】"
                                                ),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.createTime)),
                                            ]),
                                          ],
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "demo-image__preview mr15",
                                            },
                                            [
                                              _c("el-image", {
                                                attrs: {
                                                  src: scope.row.image,
                                                  "preview-src-list": [
                                                    scope.row.image,
                                                  ],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "line-height-15" },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.productName)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-909399 line-height-15 mt5",
                                              },
                                              [
                                                _vm._v(
                                                  "规格：" +
                                                    _vm._s(scope.row.sku)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle ml30",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font12 color-text",
                                                  staticStyle: {
                                                    "white-space": "nowrap",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "X " + _vm._s(scope.row.num)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { width: "400", fixed: "right" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex mr10",
                                          staticStyle: {
                                            "justify-content": "flex-end",
                                          },
                                        },
                                        [
                                          _vm.checkPermi([
                                            "platform:order:logistics:info",
                                          ]) && item.deliveryType === "express"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "ml20",
                                                  staticStyle: {
                                                    "line-height": "1",
                                                    height: "auto",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openLogistics(
                                                        item.id,
                                                        item.expressName,
                                                        item.trackingNumber
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看物流 ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return item.deliveryType === "noNeed"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font12 color-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "发货备注：" +
                                                      _vm._s(item.deliveryMark)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : undefined
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm.info.status > 4 &&
          _vm.info.status < 9 &&
          _vm.info.shippingType === 2
            ? _c("div", [
                _c("div", { staticClass: "detailSection" }, [
                  _c("ul", { staticClass: "list" }, [
                    _c("li", { staticClass: "item" }, [
                      _c("div", [_vm._v("核销员名称：")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm._f("filterEmpty")(_vm.info.clerkName)) +
                            " | " +
                            _vm._s(_vm.info.clerkId)
                        ),
                      ]),
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _c("div", [_vm._v("核销时间：")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.info.verifyTime)),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("LogisticsModal", {
        ref: "logisticsModalRef",
        attrs: {
          expressName: _vm.expressName,
          trackingNumber: _vm.trackingNumber,
          logisticsInfo: _vm.resultInfo,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }